<div class="main-content ajustes-page ficha-kpi-bsc">
  <div class="container-fluid">
    <nav class="bsc-migas" aria-label="Ruta de navegación">
      <a [routerLink]="ruta.tablero" [queryParams]="queryTablero">Tablero BSC</a>
      <span aria-hidden="true">›</span>
      <ng-container *ngIf="ficha?.idBscArea != null; else sinArea">
        <a [routerLink]="[ruta.area, ficha?.idBscArea]" [queryParams]="queryArea">
          {{ ficha?.area || "Área" }}{{ anio != null ? " " + anio : "" }}
        </a>
      </ng-container>
      <ng-template #sinArea><span>Área</span></ng-template>
      <span aria-hidden="true">›</span>
      <span aria-current="page">KPI</span>
    </nav>

    <section class="ajustes-hero ficha-kpi-bsc__hero">
      <div class="ajustes-hero__identity">
        <span class="ficha-kpi-bsc__icono" aria-hidden="true">
          <i class="material-icons">track_changes</i>
        </span>

        <div class="ajustes-hero__content">
          <h1>{{ titulo }}</h1>
          <p class="ajustes-hero__role" *ngIf="kpi?.indicador">Indicador: {{ kpi?.indicador }}</p>

          <div class="ajustes-hero__meta" *ngIf="kpi">
            <span class="ficha-kpi-bsc__sello is-meta">Meta {{ anio }}: {{ textoMeta }}</span>
            <span class="ajustes-hero__meta-text">Unidad: {{ textoUnidad }}</span>
            <span class="ajustes-hero__meta-text" *ngIf="kpi?.estatus === 'RETIRADO'">KPI retirado</span>
            <span class="ficha-kpi-bsc__sello" [class.is-abierta]="!bloqueada">
              <i class="material-icons" aria-hidden="true">{{ bloqueada ? "lock" : "lock_open" }}</i>
              {{ textoBloqueo }}
            </span>
          </div>
        </div>
      </div>

      <!-- "Editar meta" no existe: las metas quedan bloqueadas al autorizar la
           planeación (Anexo B). "Capturar <mes>" (F6.4) sale solo si se captura
           (armaCaptura). -->
      <div class="ficha-kpi-bsc__acciones">
        <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" *ngIf="kpi"
                (click)="verHistorial()">
          Historial
        </button>
        <a class="app-form-btn app-form-btn--secondary app-form-btn--compact" *ngIf="ficha?.idBscArea != null"
           [routerLink]="[ruta.area, ficha?.idBscArea]" [queryParams]="queryArea">
          Volver al área
        </a>
        <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                *ngIf="mesCaptura != null && !loading" (click)="capturarMes(mesCaptura)">
          Capturar {{ textoMes(mesCaptura) }}
        </button>
      </div>
    </section>

    <section class="ajustes-card" *ngIf="loading">
      <div class="ajustes-card__body ficha-kpi-bsc__estado">
        <i class="material-icons" aria-hidden="true">hourglass_top</i>
        <h2>Consultando la ficha</h2>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="ajustes-card" *ngIf="!loading && error">
      <div class="ajustes-card__body ficha-kpi-bsc__estado">
        <i class="material-icons" aria-hidden="true">lock_outline</i>
        <h2>No se pudo consultar la ficha</h2>
        <p>{{ error }}</p>
      </div>
    </section>

    <!-- Lo que se guardó en el cuadro de captura. La región existe siempre: así se anuncia al llegar. -->
    <output class="ficha-kpi-bsc__anuncio" aria-live="polite">
      <div class="bsc-franja ficha-kpi-bsc__guardado" *ngIf="mensajeCaptura">
        <span class="material-icons" aria-hidden="true">check_circle</span>
        <span>{{ mensajeCaptura }}</span>
      </div>
    </output>

    <ng-container *ngIf="!loading && !error && ficha">
      <output class="bsc-franja ficha-kpi-bsc__avisos" *ngIf="avisos.length > 0">
        <span class="material-icons" aria-hidden="true">info</span>
        <ul>
          <li *ngFor="let aviso of avisos">{{ aviso }}</li>
        </ul>
      </output>

      <section class="ajustes-card" *ngIf="!kpi">
        <div class="ajustes-card__body ficha-kpi-bsc__estado">
          <i class="material-icons" aria-hidden="true">report_gmailerrorred</i>
          <h2>No se pudieron leer los datos del KPI</h2>
          <p>Vuelve a intentarlo en un momento o ábrelo desde el detalle del área.</p>
        </div>
      </section>

      <div class="row ajustes-layout" *ngIf="kpi">
        <!-- ============================ Trimestres ============================ -->
        <div class="col-12 col-xl-7">
          <section class="ajustes-card ficha-kpi-bsc__trimestres" aria-labelledby="ficha-kpi-bsc-trimestres">
            <div class="ajustes-card__header">
              <div class="ajustes-card__title">
                <i class="material-icons" aria-hidden="true">calendar_view_month</i>
                <h2 id="ficha-kpi-bsc-trimestres">Trimestres</h2>
              </div>
            </div>

            <mat-tab-group [(selectedIndex)]="indice" animationDuration="0ms" class="ficha-kpi-bsc__pestanas"
                           aria-label="Trimestres del KPI">
              <mat-tab *ngFor="let p of pestanas; trackBy: trackPestana">
                <ng-template mat-tab-label>
                  <span class="ficha-kpi-bsc__punto" [ngClass]="p.punto" aria-hidden="true"></span>
                  {{ p.etiqueta }}
                  <span class="bsc-oculto" *ngIf="p.puntoTexto">, semáforo {{ p.puntoTexto }}</span>
                </ng-template>

                <div class="ficha-kpi-bsc__trimestre">
                  <header class="ficha-kpi-bsc__trimestre-cabeza">
                    <h3>{{ p.titulo }}</h3>
                    <div class="ficha-kpi-bsc__insignias">
                      <span class="table-page__status-badge" *ngIf="p.estatus" [ngClass]="p.estatus.clase">
                        <span class="material-icons" aria-hidden="true">{{ p.estatus.icono }}</span>
                        {{ p.estatus.texto }}
                      </span>
                      <span class="table-page__status-badge" *ngIf="p.semaforo" [ngClass]="p.semaforo.clase">
                        <span class="material-icons" aria-hidden="true">{{ p.semaforo.icono }}</span>
                        {{ p.semaforo.texto }}
                      </span>
                    </div>
                  </header>

                  <dl class="ficha-kpi-bsc__cifras">
                    <div *ngFor="let c of p.cifras">
                      <dt>{{ c.etiqueta }}</dt>
                      <dd>{{ c.valor }}</dd>
                      <dd class="ficha-kpi-bsc__ayuda">{{ c.ayuda }}</dd>
                    </div>
                  </dl>

                  <p class="ficha-kpi-bsc__nota-q" *ngIf="p.nota">
                    <i class="material-icons" aria-hidden="true">info</i>
                    {{ p.nota }}
                  </p>

                  <div class="ficha-kpi-bsc__meses">
                    <article class="ficha-kpi-bsc__mes" *ngFor="let m of p.meses; trackBy: trackMes">
                      <header>
                        <h4>{{ m.nombre }}</h4>
                        <span class="table-page__status-badge" *ngIf="m.estado" [ngClass]="m.estado.clase">
                          <span class="material-icons" aria-hidden="true">{{ m.estado.icono }}</span>
                          {{ m.estado.texto }}
                        </span>
                      </header>
                      <ng-container *ngIf="!m.vacio; else mesVacio">
                        <ng-container *ngIf="m.actividad">
                          <span class="ficha-kpi-bsc__rotulo">Actividad planeada</span>
                          <p>{{ m.actividad }}</p>
                        </ng-container>
                        <ng-container *ngIf="m.evidencia">
                          <span class="ficha-kpi-bsc__rotulo">Evidencia / resultado</span>
                          <p>{{ m.evidencia }}</p>
                        </ng-container>
                        <small *ngIf="m.capturo">{{ m.capturo }}</small>
                      </ng-container>
                      <ng-template #mesVacio>
                        <p class="ficha-kpi-bsc__mes-vacio">{{ m.vacio }}</p>
                      </ng-template>
                      <button type="button" class="ficha-kpi-bsc__capturar" *ngIf="m.capturable"
                              [attr.aria-label]="(m.vacio ? 'Capturar ' : 'Editar ') + textoMes(m.mes) + ' de ' + titulo"
                              (click)="capturarMes(m.mes)">
                        <i class="material-icons" aria-hidden="true">{{ m.vacio ? "edit_calendar" : "edit" }}</i>
                        {{ m.vacio ? "Capturar" : "Editar" }}
                      </button>
                    </article>
                  </div>

                  <dl class="ficha-kpi-bsc__pie" *ngIf="p.pie.length > 0">
                    <div *ngFor="let x of p.pie">
                      <dt>{{ x.etiqueta }}</dt>
                      <dd>{{ x.valor }}</dd>
                    </div>
                  </dl>
                </div>
              </mat-tab>
            </mat-tab-group>
          </section>
        </div>

        <!-- ============================ Lateral ============================ -->
        <div class="col-12 col-xl-5">
          <section class="ajustes-card" aria-labelledby="ficha-kpi-bsc-acumulado">
            <div class="ajustes-card__header">
              <div class="ajustes-card__title">
                <i class="material-icons" aria-hidden="true">bar_chart</i>
                <h2 id="ficha-kpi-bsc-acumulado">Acumulado programado vs real</h2>
              </div>
            </div>
            <div class="ajustes-card__body">
              <app-acumulado-q-bsc [real]="serieReal" [programado]="serieProgramado"
                                   nombreReal="Real acumulado (L)" nombreProgramado="Programado acumulado (N)"
                                   [descripcion]="'Acumulado de ' + titulo + ' por trimestre'"></app-acumulado-q-bsc>
              <p class="ficha-kpi-bsc__nota">Lo real se pinta hasta el último trimestre con avance capturado.</p>
            </div>
          </section>

          <section class="ajustes-card" aria-labelledby="ficha-kpi-bsc-pesos">
            <div class="ajustes-card__header">
              <div class="ajustes-card__title">
                <i class="material-icons" aria-hidden="true">balance</i>
                <h2 id="ficha-kpi-bsc-pesos">Pesos por trimestre</h2>
              </div>
            </div>
            <div class="ajustes-card__body">
              <ul class="ficha-kpi-bsc__pesos">
                <li *ngFor="let p of pesos" [class.is-na]="p.na">
                  <span>Q{{ p.q }}</span>
                  <strong>{{ p.valor }}</strong>
                </li>
              </ul>
              <p class="ficha-kpi-bsc__suma" [class.is-aviso]="sumaPesosAviso">{{ textoSumaPesos }}</p>
              <p class="ficha-kpi-bsc__nota">
                Meta y pesos se fijan en la planeación y quedan bloqueados al autorizarse; solo cambian al planear el
                año siguiente, con su motivo en el historial.
              </p>
            </div>
          </section>

          <section class="ajustes-card" aria-labelledby="ficha-kpi-bsc-descripcion">
            <div class="ajustes-card__header">
              <div class="ajustes-card__title">
                <i class="material-icons" aria-hidden="true">description</i>
                <h2 id="ficha-kpi-bsc-descripcion">Descripción y beneficios</h2>
              </div>
            </div>
            <div class="ajustes-card__body ficha-kpi-bsc__textos">
              <ng-container *ngIf="kpi?.descripcion || kpi?.beneficios || kpi?.comentarios; else sinTextos">
                <ng-container *ngIf="kpi?.descripcion">
                  <span class="ficha-kpi-bsc__rotulo">Descripción</span>
                  <p>{{ kpi?.descripcion }}</p>
                </ng-container>
                <ng-container *ngIf="kpi?.beneficios">
                  <span class="ficha-kpi-bsc__rotulo">Beneficios</span>
                  <p>{{ kpi?.beneficios }}</p>
                </ng-container>
                <ng-container *ngIf="kpi?.comentarios">
                  <span class="ficha-kpi-bsc__rotulo">Comentarios</span>
                  <p>{{ kpi?.comentarios }}</p>
                </ng-container>
              </ng-container>
              <ng-template #sinTextos>
                <p class="ficha-kpi-bsc__nota">La planeación no trae descripción ni beneficios de este KPI.</p>
              </ng-template>
            </div>
          </section>

          <section class="ajustes-card" aria-labelledby="ficha-kpi-bsc-anterior">
            <div class="ajustes-card__header">
              <div class="ajustes-card__title">
                <i class="material-icons" aria-hidden="true">history_toggle_off</i>
                <h2 id="ficha-kpi-bsc-anterior">Mismo KPI en {{ anio != null ? anio - 1 : "el año anterior" }}</h2>
              </div>
            </div>
            <!-- F7.3: tile compacto; los números (L al mismo trimestre y su diferencia) son del servidor. -->
            <div class="ajustes-card__body">
              <dl class="ficha-kpi-bsc__contra" *ngIf="contraCifras.length > 0"
                  aria-label="Acumulado del KPI en los dos años al mismo trimestre">
                <div *ngFor="let c of contraCifras" [ngClass]="c.clase">
                  <dt>{{ c.etiqueta }}</dt>
                  <dd>{{ c.valor }}</dd>
                </div>
              </dl>
              <p class="ficha-kpi-bsc__contra-nota" *ngIf="contraNota" [ngClass]="contraNotaClase">{{ contraNota }}</p>
              <ul class="ficha-kpi-bsc__anterior" *ngIf="anteriorTexto.length > 0">
                <li *ngFor="let t of anteriorTexto">{{ t }}</li>
              </ul>
              <a class="ficha-kpi-bsc__enlace" *ngIf="puedeComparar && contraEnlace" [routerLink]="ruta.comparativo"
                 [queryParams]="queryComparativo">
                Comparar los dos años
              </a>
            </div>
          </section>
        </div>

        <!-- ============================ Historial ============================ -->
        <div class="col-12">
          <section class="ajustes-card" aria-labelledby="ficha-kpi-bsc-historial">
            <div class="ajustes-card__header">
              <div class="ajustes-card__title">
                <i class="material-icons" aria-hidden="true">history</i>
                <h2 id="ficha-kpi-bsc-historial" tabindex="-1" #historialTitulo>Historial</h2>
              </div>
            </div>
            <div class="ajustes-card__body">
              <ol class="ficha-kpi-bsc__historial" *ngIf="historial.length > 0; else sinHistorial">
                <li *ngFor="let h of historial">
                  <div class="ficha-kpi-bsc__historial-cabeza">
                    <strong>{{ h.accion }}</strong>
                    <span class="ficha-kpi-bsc__sello is-otro" *ngIf="h.otroAnio">Otro año</span>
                    <time>{{ h.fecha }}</time>
                  </div>
                  <p *ngFor="let d of h.detalle">{{ d }}</p>
                  <small>{{ h.usuario }}</small>
                </li>
              </ol>
              <ng-template #sinHistorial>
                <p class="ficha-kpi-bsc__nota">Sin movimientos registrados para este KPI.</p>
              </ng-template>
            </div>
          </section>
        </div>
      </div>
    </ng-container>
  </div>
</div>
